import React, { useMemo } from "react";
import * as OrderUtils from "@/utils/OrderUtils";
import OrderDTO from "@/dto/order/OrderDTO";
import { useGlobalStore } from "@/store/hooks";
import { observer } from "mobx-react-lite";
import { useModalStore } from "@/hooks/Modal/hooks";
import UpdateSellerRemarksModal from "../../../dialogs/UpdateSellerRemarksDialog/UpdateSellerRemarksModal";
import { SupplierShopTypes } from "@/utils/ShopUtils";
import ShopType from "@/enum/ShopType";
import TbUpdateSellerRemarksModal from "../../../dialogs/TbUpdateSellerRemarksModal";
import { buildFlagTag } from "@/utils/OrderUtils";
import OrderMergeSplitStatus from "@/enum/OrderMergeSplitStatus";
import { isEmpty } from "@/utils";

interface SellerRemarksProps {
    order: OrderDTO;
    onUpdateOrder?: (orderId: number, props: { sellerRemarks: OrderDTO["sellerRemarks"] }) => void;
    className?: string;
}

const SellerRemarks: React.FC<SellerRemarksProps> = function (props) {
    const { order, onUpdateOrder, className } = props;
    const { shopMapping } = useGlobalStore();
    const modalStore = useModalStore();

    function handleUpdateSellerRemarkBtnClick(e) {
        e.preventDefault();

        if (shop.type === ShopType.TAOBAO) {
            modalStore.openModal(TbUpdateSellerRemarksModal, {
                order,
                onUpdateOrder,
            });
        } else {
            modalStore.openModal(UpdateSellerRemarksModal, {
                order,
                onUpdateOrder,
            });
        }
    }

    const currentSellerRemarks = OrderUtils.buildSellerRemarks(order);

    const shop = shopMapping.get(order.shopId);

    const isSupplierShop = SupplierShopTypes.includes(shop?.type);

    /**
     * 满足以下条件显示备注元素
     * 1.有备注内容
     * 2.淘宝店铺，并且订单内包含旗帜内容的
     */

    const shouldShowRemarks = useMemo(() => {
        if (currentSellerRemarks) return true;

        if ([ShopType.TAOBAO].includes(shop.type)) {
            if (order.mergeSplitStatus === OrderMergeSplitStatus.MERGE_PARENT && order.childOrders) {
                for (const childOrder of order.childOrders) {
                    if (!isEmpty(childOrder.sellerRemarks?.flagTag)) return true;
                }
            } else {
                if (!isEmpty(order.sellerRemarks?.flagTag)) return true;
            }
        }

        return false;
    }, [currentSellerRemarks]);

    const remarkNode = shouldShowRemarks ? (
        <span>
            备注：
            {buildFlagTag(order)}
            {currentSellerRemarks}
        </span>
    ) : null;

    const retailerRemarkNode = shouldShowRemarks ? (
        <span>
            {remarkNode}

            {order?.sellerRemarks?.content && order?.sellerRemarks?.localContent && (
                <span className="small text-light2 ml5">(平台备注：{order.sellerRemarks.content})</span>
            )}

            <a onClick={handleUpdateSellerRemarkBtnClick} href="#" className="ml5 text-light link-btn mr5">
                修改
            </a>
        </span>
    ) : (
        <>
            <a onClick={handleUpdateSellerRemarkBtnClick} href="#" className="text-light link-btn">
                添加备注
            </a>
        </>
    );

    return <span className={className}>{isSupplierShop ? remarkNode : retailerRemarkNode}</span>;
};

export default observer(SellerRemarks);
